/* eslint-disable no-restricted-globals */
import ResolutionImage, {
    SRC_WIDTH_MAP,
} from 'ggApp/shared/components/resolutionImage/ResolutionImage';

function buildSrcSet(imgUrls) {
    const scrSetAsArray = Object.keys(imgUrls).reduce((accum, key) => {
        const src = imgUrls[key];
        if (typeof src === 'string') {
            const width = SRC_WIDTH_MAP[key];
            if (!isNaN(width)) {
                accum.push(`${src} ${width}w`);
            }
        }
        return accum;
    }, []);
    return scrSetAsArray.join(', ');
}

/**
 * For proper explanation of srcset, sizes img attributes usage please refer to link:
 * https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images
 * in a word, srcset is attribute for img's "src" switching based on viewport size (resolution)(DPR is taken into account too)
 * ex usage:
 * <ResolutionResizeImage
 *   imgUrls={{
 *      mini_square: 'mini_square_src',
        small_square: 'small_square_src',
        dashboard_square: 'dashboard_square_src',
        medium_square: 'medium_square_src',
        large_square: 'large_square_src',
        x_large_square: 'x_large_square_src',
        x2_large_square: 'x2_large_square_src',
 *   }}
 *    sizes={{
 *      mobile: 100px,
        tablet: 100vw,
        desktop: 40vw,
        default: 100vw,
 *   }}
 * />
 */
const ProductResolutionImage = ResolutionImage(buildSrcSet);

export default ProductResolutionImage;
